export const currentUserSelector = () => state => state.currentUser;